import React from 'react';
interface EscrowProcessProps {
  icon: ReactNode;
  title: string;
  description: string;
  step: number;
}
const EscrowProcess: React.FC<EscrowProcessProps> = ({
  icon,
  title,
  description,
  step
}) => {
  return <div className="flex flex-col items-center text-center relative" data-id="element-147">
      <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-3" data-id="element-148">
        {icon}
      </div>
      <div className="absolute top-7 left-full w-full h-0.5 bg-blue-100 hidden md:block" style={{
      width: 'calc(100% - 4rem)'
    }} data-id="element-149">
        {step < 5 && <div className="absolute right-0 top-1/2 transform -translate-y-1/2 -translate-x-1/2 w-3 h-3 rotate-45 border-t-2 border-r-2 border-blue-100" data-id="element-150"></div>}
      </div>
      <h3 className="font-medium mb-1" data-id="element-151">{title}</h3>
      <p className="text-sm text-gray-600" data-id="element-152">{description}</p>
    </div>;
};
export default EscrowProcess;